import {CxEvent} from '@spartacus/core';

export class EddlStBeaconEvent extends CxEvent {
  static readonly type = 'EddlStBeaconEvent';
}
